// GooglePlus was deprecated in April of 2019. Keeping it here lets existing
// elements to render. We could eventually create a DeprecatedElement Atom or
// Plugin Component and write a migration to convert GooglePlus elements to it.

import React from 'react';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Plugins, Atom} from '@packages/systems/wfdl';

const render = Atom.createRender(
  ({attributes, classes, generateAttributes}) => (
    <div
      {...generateAttributes(attributes, classes)}
      style={{
        border: '1px solid lightgray',
        padding: '1rem',
        textAlign: 'center',
      }}
    >
      Google+ has been discontinued. To ensure a better user experience, please
      consider removing this element from your site.
    </div>
  )
);

const config = Atom.create({
  displayName: 'Deprecated Google+',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Div')),
  },
  showEmpty: false,
  render,
});

export default config;
